import { Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import KbbLogo from 'assets/logos/kbb-logo.png';

const useStyles = makeStyles()((theme) => ({
  mainTitle: {
    margin: theme.spacing(1.5, 0, 4.5, 0),
  },
  topSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: theme.spacing(10),
  },
  middleSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  kbbLogo: {
    height: 86,
    width: 'auto',
  },
}));

export const FetchStep = () => {
  const { classes } = useStyles();

  return (
    <>
      <Box className={classes.topSection}>
        <Typography variant='headlineMedium' className={classes.mainTitle}>
          Valuating your vehicle
        </Typography>
        <CircularProgress size={128} />
      </Box>
      <Box className={classes.middleSection}>
        <Typography variant='paragraphRegular'>Downloading data...</Typography>
        <Box>
          <img src={KbbLogo} alt={'Kelley Blue Book logo'} className={classes.kbbLogo} />
        </Box>
      </Box>
    </>
  );
};
